'use client';

import Link from 'next/link';
import type { OpdsFacetGroup, LibraryConnection } from '@/lib/opds/types';
import { encodeFeedPath } from '@/lib/utils/url';

export function FacetBar({
  facets,
  library,
}: {
  facets: OpdsFacetGroup[];
  library: LibraryConnection;
}) {
  if (facets.length === 0) return null;

  return (
    <div className="space-y-3 pb-4">
      {facets.map((group) => (
        <div key={group.label}>
          <span className="mr-2 text-xs font-semibold uppercase tracking-wider text-neutral-400">
            {group.label}
          </span>
          <div className="mt-1 flex flex-wrap gap-1.5">
            {group.facets.map((facet) => (
              <Link
                key={facet.href}
                href={`/library/${library.id}/feed/${encodeFeedPath(facet.href)}`}
                className={`rounded-full px-3 py-1 text-xs font-medium transition-colors ${
                  facet.isActive
                    ? 'bg-blue-600 text-white'
                    : 'bg-neutral-100 text-neutral-600 hover:bg-neutral-200'
                }`}
              >
                {facet.title}
                {facet.count != null && (
                  <span className="ml-1 opacity-60">({facet.count})</span>
                )}
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
